(() => {
  const configElement = document.getElementById('PkHubSpotFormRoutingConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('HubSpot-Formularzuordnung: Konfiguration ist ungültig.', error);
    return;
  }

  const portalId = String(config.portalId || '').trim();
  const routes = config.routes || {};
  const formGuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if (!/^\d+$/.test(portalId)) return;

  const readValue = (formData, name) => String(formData.get(name) || '').trim();

  const splitName = (fullName) => {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    return {
      firstName: parts.shift() || '',
      lastName: parts.join(' '),
    };
  };

  const routeFor = (form) => {
    if (form.matches('.pk-object-contact-form')) {
      const requestType = readValue(new FormData(form), 'contact[Anfrageart]');
      return {
        ...routes.object,
        kind: 'object',
        source: requestType === 'Ausschreibung' ? 'Ausschreibung' : 'Website',
        formLabel: requestType || 'Objektprojekt',
      };
    }
    if (form.matches('.pk-contact-form')) return { ...routes.private, kind: 'private' };
    if (form.matches('.newsletter-form')) return { ...routes.newsletter, kind: 'newsletter' };
    return null;
  };

  const messageFor = (formData, route) => {
    const message = readValue(formData, 'contact[body]');
    if (route.kind !== 'object') return message;

    const details = [
      ['Branche', readValue(formData, 'contact[Branche]')],
      ['Projektort', readValue(formData, 'contact[Projektort]')],
      ['Menge', readValue(formData, 'contact[Menge]')],
      ['Zeitraum', readValue(formData, 'contact[Zeitraum]')],
    ]
      .filter(([, value]) => value)
      .map(([label, value]) => `${label}: ${value}`);

    return [message, ...details].filter(Boolean).join('\n\n');
  };

  const payloadFor = (form, route) => {
    const formData = new FormData(form);
    const fullName = readValue(formData, 'contact[name]');
    const split = splitName(fullName);
    const firstName = readValue(formData, 'contact[Vorname]') || split.firstName;
    const lastName = readValue(formData, 'contact[Nachname]') || split.lastName;
    const values = {
      email: readValue(formData, 'contact[email]'),
      firstname: firstName,
      lastname: lastName,
      phone: readValue(formData, 'contact[phone]'),
      company: readValue(formData, 'contact[Unternehmen]'),
      message: messageFor(formData, route),
      form: route.formLabel || '',
      kundensegment: route.segment || '',
      anfragequelle: route.source || '',
    };

    const context = {
      pageUri: `${window.location.origin}${window.location.pathname}`,
      pageName: document.title,
    };

    const payload = {
      submittedAt: String(Date.now()),
      fields: Object.entries(values)
        .filter(([, value]) => value)
        .map(([name, value]) => ({ name, value })),
      context,
    };

    return payload;
  };

  const submitToHubSpot = async (formId, payload) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true,
          signal: controller.signal,
        }
      );
      if (!response.ok) {
        const details = await response.text();
        throw new Error(`HTTP ${response.status}: ${details.slice(0, 500)}`);
      }
    } finally {
      window.clearTimeout(timeout);
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.pkHubspotBypass === 'true') return;

    const route = routeFor(form);
    const formId = String(route?.formId || '').trim();
    if (!route || !formGuidPattern.test(formId)) return;

    const payload = payloadFor(form, route);
    if (!payload.fields.some((field) => field.name === 'email')) return;

    event.preventDefault();
    const submitter = event.submitter;
    if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) submitter.disabled = true;

    try {
      await submitToHubSpot(formId, payload);
    } catch (error) {
      console.error('HubSpot-Formularzuordnung fehlgeschlagen; Shopify-Anfrage wird trotzdem gesendet.', error);
    } finally {
      if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) submitter.disabled = false;
      form.dataset.pkHubspotBypass = 'true';
      // Trigger a regular submit event again so Shopify can attach its
      // CAPTCHA token and run any other native form handlers. Calling the
      // prototype's submit method directly bypasses those handlers.
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter || undefined);
      } else {
        form.submit();
      }
    }
  });
})();
